<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/organization/process/harvest_export/new_exported_batch.yml"
  lang="yaml"
></i18n>
<template>
  <div>
    <div class="py-4" v-for="(exported_package, index) in exported_packages" :key="index">
      <template v-if="!exported_package._destroy">
        <div class="flex justify-end">
          <span @click.prevent="removeExpPackage(index)">
            <i class="fa-solid fa-xmark fa-xl text-gray-400 cursor-pointer"></i>
          </span>
        </div>
        <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-3">
          <div class="sm:col-span-1">
            <label class="label-form">
              {{ $t("model.package.exporter_process_crop_package") }}
            </label>
            <div class="mt-1" v-if="crop_exp_packages.length > 1">
              <select-form :options="crop_exp_packages" @input="updateValuesByExpPackace(index)"
                v-model="exported_package.exporter_process_crop_package_id" />
            </div>
            <dd class="content-data" v-else-if="crop_exp_packages.length == 1">
              {{ crop_exp_packages[0].name }}
            </dd>
          </div>
          <div class="sm:col-span-1" v-if="crop_categories.length > 1">
            <label class="label-form">
              {{ $t("model.package.exporter_process_crop_category") }}
            </label>
            <div class="mt-1" v-if="crop_categories.length > 1">
              <select-form :options="crop_categories" v-model="exported_package.exporter_process_crop_category_id" />
            </div>
            <dd class="content-data" v-else-if="crop_categories.length == 1">
              {{ crop_categories[0].name }}
            </dd>
          </div>
          <div class="sm:col-span-1" v-if="crop_varieties.length > 1">
            <label class="label-form">
              {{ $t("model.package.exporter_process_crop_variety") }}
            </label>
            <div class="mt-1" v-if="crop_varieties.length > 1">
              <select-form :options="crop_varieties" v-model="exported_package.exporter_process_crop_variety_id" />
            </div>
            <dd class="content-data" v-else-if="crop_varieties.length == 1">
              {{ crop_varieties[0].name }}
            </dd>
          </div>
          <div class="sm:col-span-1" v-if="crop_sizes.length > 1">
            <label class="label-form">
              {{ $t("model.package.exporter_process_crop_size") }}
            </label>
            <div class="mt-1" v-if="crop_sizes.length > 1">
              <select-form :options="crop_sizes" v-model="exported_package.exporter_process_crop_size_id" />
            </div>
            <dd class="content-data" v-else-if="crop_sizes.length == 1">
              {{ crop_sizes[0].name }}
            </dd>
          </div>
          <div class="sm:col-span-1">
            <label class="label-form">
              {{ $t("model.package.exporter_process_brand") }}
            </label>
            <div class="mt-1" v-if="brands.length > 1">
              <select-form :options="brands" v-model="exported_package.exporter_process_brand_id" />
            </div>
            <dd class="content-data" v-else-if="brands.length == 1">
              {{ brands[0].name }}
            </dd>
          </div>
          <div class="sm:col-span-1">
            <label class="label-form">
              {{ $t("model.package.quantity") }}
            </label>
            <div class="mt-1">
              <input type="text" v-model.trim="exported_package.quantity"
                :class="['input-text', isInvalid('quantity')]" />
            </div>
          </div>
        </div>
        <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-3 mt-2"
          v-for="(inspect, inspect_index) in exported_package.package_quality_inspects" :key="inspect_index">
          <template v-if="!inspect._destroy">
            <div class="sm:col-span-1">
              <label class="label-form">
                {{ $t("model.package.quantity") }} {{ quality_templates.find(q => q.id ==
                  inspect.quality_template_id).name }}
              </label>
              <div class="mt-1">
                <input type="text" v-model.number="inspect.discarded_packages" :class="['input-text']" />
              </div>
            </div>
            <div class="sm:col-span-1">
              <label class="label-form">
                {{ $t("model.quality_inspect.observations") }} {{ quality_templates.find(q => q.id ==
                  inspect.quality_template_id).name }}
              </label>
              <div class="mt-1">
                <textarea v-model="inspect.observations" rows="3" :class="['input-text-area']" />
              </div>
            </div>
            <div>
              <span @click.prevent="removeInspect(index, inspect_index)">
                <i class="fa-solid fa-xmark fa-xl text-gray-400 cursor-pointer"></i>
              </span>
            </div>
          </template>
        </div>
        <div class="flex justify-end mt-4" v-for="quality_template in quality_templates" :key="quality_template.id">
          <white-button @click.prevent="addQualityInspect(index, quality_template)"
            :label="$t('labels.add_quality_inspect_button') + ' ' + quality_template.name" />
        </div>
      </template>
    </div>
    <div class="flex justify-end mt-4">
      <white-button @click.prevent="addExpPackage()" :label="$t('labels.add_package_button')" />
    </div>
  </div>
</template>

<script>
import Requester from "@/views/organization/requesters/process/harvest_export/manage_exported_batch.js";

export default {
  name: "OrgProcessHarvestExportPackages",
  components: {},
  data() {
    return {
      exported_package_default: {
        id: null,
        exporter_process_crop_package_id: null,
        exporter_process_crop_category_id: null,
        exporter_process_crop_variety_id: null,
        exporter_process_crop_size_id: null,
        exporter_process_brand_id: null,
        quantity: null,
        package_quality_inspects: [],
        from_stock: true
      },
      exported_packages: this.modelValue,
      crop_varieties: [],
      brands: []
    };
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    organization_id: { required: true },
    agro_exporter_process_id: { required: true },
    agro_exporter_processes: { required: true },
    crop_categories: { required: true },
    crop_exp_packages: { required: true },
    crop_sizes: { required: true }
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData: async function () {
      await this.fetchCropVarieties();
      await this.fetchAgroExporterBrands();
      this.exported_package_default.exporter_process_crop_package_id =
        this.hasOneItem(this.crop_exp_packages);
      this.exported_package_default.exporter_process_crop_category_id =
        this.hasOneItem(this.crop_categories);
      this.exported_package_default.exporter_process_crop_size_id =
        this.hasOneItem(this.crop_sizes);
      if (this.exported_packages.length == 0) this.addExpPackage();
    },
    fetchCropVarieties: async function () {
      const response = await Requester.fetchExporterProcessCropVarieties(
        this.organization_id,
        this.agro_exporter_process_id
      );
      this.crop_varieties = response.data;
      this.exported_package_default.exporter_process_crop_variety_id =
        this.hasOneItem(this.crop_varieties);
    },
    fetchAgroExporterBrands: async function () {
      const response = await Requester.fetchExporterProcessBrands(
        this.organization_id,
        this.agro_exporter_process_id
      );
      this.brands = response.data;
      this.exported_package_default.exporter_process_brand_id = this.hasOneItem(
        this.brands
      );
    },
    addQualityInspect: function (package_index, quality_template) {
      let exported_package = this.exported_packages[package_index];
      const default_inspect = {
        id: null,
        quality_template_id: quality_template.id,
        discarded_packages: null,
        observations: ''
      };
      exported_package.package_quality_inspects = [...exported_package.package_quality_inspects || [], default_inspect];
    },
    addExpPackage: function () {
      this.exported_packages.push({ ...this.exported_package_default });
    },
    removeExpPackage: function (index) {
      if (this.exported_packages[index].id) {
        this.exported_packages[index]._destroy = true;
      } else this.exported_packages.splice(index, 1);

      if (
        this.exported_packages.filter(
          exp_pkg => exp_pkg._destroy == false || exp_pkg.id == null
        ).length == 0
      )
        this.addExpPackage();
    },
    removeInspect: function (index, inspect_index) {
      let exported_package = this.exported_packages[index];
      let package_quality_inspect = exported_package.package_quality_inspects[inspect_index];
      if (package_quality_inspect.id) {
        package_quality_inspect._destroy = true;
      } else exported_package.package_quality_inspects.splice(inspect_index, 1);
    },
    hasOneItem: function (array) {
      return array.length == 1 ? array[0].id : null;
    },
    updateValuesByExpPackace: function (index) {
      let exported_package = this.exported_packages[index];
      let exporter_process_crop_package_id = exported_package.exporter_process_crop_package_id;
      let crop_exp_package = this.crop_exp_packages.find(cep => cep.id == exporter_process_crop_package_id)
      let exporter_process_brand_id = crop_exp_package.exporter_process_brand_id;
      if (exporter_process_brand_id) exported_package.exporter_process_brand_id = exporter_process_brand_id;
    }
  },
  computed: {
    quality_templates: function () {
      if (!this.agro_exporter_processes) return [];
      let aep = this.agro_exporter_processes.find(p => p.id = this.agro_exporter_process_id);
      return aep?.quality_templates || [];
    }
  }
};
</script>
